var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPlayerIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.272,
    height: 15,
    viewBox: "0 0 15.272 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6288",
    "data-name": "Group 6288",
    transform: "translate(-268.384 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6286",
    "data-name": "Group 6286",
    transform: "translate(268.384 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-shield",
    "data-name": "Icon awesome-user-shield",
    d: "M6.562,7.5a3.75,3.75,0,1,0-3.75-3.75A3.75,3.75,0,0,0,6.562,7.5Zm1.27,1.245a4.02,4.02,0,0,1-1.27.161,5.116,5.116,0,0,1-2.136-.469H3.937A3.939,3.939,0,0,0,0,12.375v1.219A1.407,1.407,0,0,0,1.406,15H7.832Z",
    transform: "translate(0)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-bars",
    "data-name": "Icon metro-chart-bars",
    d: "M2.571,12.327h8.111v1.234H2.571ZM3.805,8.012H5.04v3.7H3.805ZM5.657,5.543H6.891V11.71H5.657ZM7.509,7.4H8.743V11.71H7.509Zm1.852-3.7h1.234V11.71H9.36Z",
    transform: "translate(272.974 65.438)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPlayerIco);
export default __webpack_public_path__ + "static/media/new-player-ico.83a48e6a.svg";
export { ForwardRef as ReactComponent };